
import { writable } from 'svelte/store';

export const showLogin = writable(false);
export const showSignUp = writable(false);

export function getTopic(topic) {

}